export default "__VITE_ASSET__CzOXOBRu__"